var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInclinedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7426 4.39128L12.639 4.22593C13.0299 4.1749 13.3918 4.42412 13.4595 4.79082L14.9416 12.7119C14.9927 13.1027 14.7435 13.4647 14.3768 13.5323L6.43155 14.9979C6.06485 15.0655 5.70289 14.8163 5.61112 14.433L5.44577 13.5366C5.39475 13.1458 5.64396 12.7838 6.02728 12.6921L10.8577 11.9274L3.93233 7.1591C3.5945 6.9265 3.51935 6.51905 3.75195 6.18123L4.28361 5.40906C4.4996 5.09537 4.92366 4.99608 5.26148 5.22868L12.1869 9.99703L11.1611 5.23584C11.1101 4.845 11.3352 4.46644 11.7426 4.39128Z",
    fill: "#002744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclinedArrow);
export default __webpack_public_path__ + "static/media/inclinedArrow.10d3d24cf90adce0f2cf6bd690edf112.svg";
export { ForwardRef as ReactComponent };